import React from 'react';
import {Container, Row ,Col} from 'react-bootstrap';

  const Footer = () => {

    return(
        
    <footer>  
      <div class="container">
        <div class="footer-col">
         <h4>Legal Statement</h4>
         <p>Bridgeway Microfinance Bank reserves the right to withold banking services 
                to it's members, on the premise that there is a suspected breach of already 
                established terms and conditions. These terms and conditions are subject to change at any time;
                 appropriate parties will be informed.</p>
            <br/>
            <br/>
            
            <p> RC:  1297837</p>
            <div class="social-icons-footer">
              <i class="fa fa-facebook-square"></i>
              <i class="fa fa-twitter-square"></i>
              <i class="fa fa-linkedin-square"></i> 
            </div> {/*<!--social-icons-footer ending-->*/}<br/>
        </div> {/*<!--footer-col ending-->*/}
     
        
     
        <div class="footer-col footer-2-col">
         <h4>Quick Links</h4>
         <div class="social-icons-footer">
         <ul>
           <li> <a href="https://bridgewaymfb.com/#welcome">See Balance</a></li>
           <li> <a href="https://bridgewaymfb.com/#why-choose-us">About Us</a> </li>
           <li> <a href="https://bridgewaymfb.com/#bank-careers">Available Jobs</a></li>
           <li> <a href="https://bridgewaymfb.com/#feature-sec">Products</a></li>
           <li> <a href="https://bridgewaymfb.com/#expand">Spotlight</a></li>
           <li>  <a href="https://bridgewaymfb.com/#contact">Contact Us</a></li>
         </ul>
            </div> {/*<!--social-icons-footer ending-->*/}
        </div> {/* <!--footer-col ending-->*/}
     
     
        <div class="footer-col contact-icon">
         <h3>Contact Us</h3>
         <p> <i class="fa fa-envelope-o"></i> <a href="mailto:adijatodubanjo@bridgewaymfb.com">adijatodubanjo@bridgewaymfb.com</a>  </p>
         <p> <i class="fa fa-mobile-phone"></i> <a href="tel:08152222536">08152222536</a>  </p>
         <p> <i class="fa fa-map-o"></i> <span>49A Lafiaji Way, Dolphin Estate, Ikoyi,Lagos</span>  </p>
               
        </div> {/*<!--footer-col ending-->*/}
     
         <div class="clear"></div>
     
          <hr class="footer-hr"/>
          <p class="copyright-footer">
          &copy; 2022 - Bridgeway Microfinance Bank. All Rights Reserved.
         </p> {/*<!--copyright-footer ending-->*/}
     
     </div> {/*<!--container ending-->*/}
         {/*<!--footer ending-->*/}
  </footer> 
    )
}

export default Footer;
